import {selectEnergyUnit} from '@/api/EnergyUnit'

let map = []

/**
 *
 *能耗单元树
 * @param customerId 必填
 * @param ids 口径id数组,null查询所有口径下的能耗单元
 * @param type 1,2,null;1查询到,null查询全部
 * @param meterUnitType 1,2;1水表,2电表
 * @param enabled 1查询启用 0查询未启用 null查询所有
 * @returns {Promise<any>}
 *
 */
export function tree(customerId, ids, type, meterUnitType, enabled) { /* 口径下能耗单元树*/
  return new Promise((resolve, reject) => {
    selectEnergyUnit(customerId, ids, type, meterUnitType,enabled).then(response => {
      if (response.code === 200) {
        const tree = []
        tree.push({
          label: '口径设置',
          treeGrade: 4,
          children: [],
          id: 1,
          type: null,
          typeId: null
        })
        const data = response.infoJson
        for (var i in data) {
          const approach = JSON.parse(i)
          tree[0].children.push({
              id: approach.id,
              label: approach.name,
              order: approach.order,
              treeGrade: 3,
              note: approach.note,
              enabled: approach.enabled,
              type: approach.type,
              typeId: null,
              children: getChild(data[i], approach, approach.name)
            }
          )
        }
        /* for (var i in data) {
          const approach = JSON.parse(i)
          tree.push({
            id: approach.id,
            label: approach.name,
            order: approach.order,
            treeGrade: 3,
            note: approach.note,
            enabled: approach.enabled,
            type: approach.type,
            children: getChild(data[i], approach, approach.name)
          }
          )
        }*/
        resolve(tree)
      } else {
        reject(response.message)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

/**
 * 生成树形结构数据
 * @param child
 * @param father
 * @param name
 * @returns {*}
 */
function getChild(child, father, name) { /* 子节点*/
  if (child == null || child.length === 0) return
  const children = []
  for (let j = 0; j < child.length; j++) {
    children.push(
      {
        treeGrade: child[j].type,
        id: child[j].id,
        label: child[j].name,
        grade: child[j].grade,
        enabled: child[j].enabled,
        order: child[j].order,
        customerId: child[j].customerId,
        note: child[j].note,
        code: child[j].code,
        type: child[j].type,
        approachId: child[j].approachId,
        approachName: name,
        father: father,
        typeId: child[j].typeId,
        children: getChild(child[j].children, child[j], name)
      }
    )
  }
  return children
}

/**
 * 获取树形结构首个包含仪表能耗单元用户
 * @param data
 * @returns {*}
 */
export function expandedCustomerWithMeter(data) {
  if (data === null || data === undefined) return
  for (const i in data) {
    if (data[i].type + '' === '1' && data[i].children !== undefined && data[i].children !== null) {
      map = []
      map.push({customerId: data[i].id})
      map.push({meterId: []})
      map.push({energyId: []})
      map.push({name:data[i].label})
      return getMeterEnergyIds(data[i].children)
    }

    if (data[i].children !== undefined || data[i].children !== null) {
      const ret = expandedCustomerWithMeter(data[i].children)
      if (ret) return ret
    } else {
      return null
    }
  }
}

export function expandedFirstTop(data) {
  map = []
  if (data === null || data === undefined) return
  for (const i in data) {
    if (data[i].type === 'building') {
      map.push({customerId: data[i].id})
      map.push({meterId: []})
      map.push({energyId: []})
      map.push({name:data[i].label})
      return getMeterEnergyIds1(data[i].children)
    }else{
      const ret = expandedFirstTop(data[i].children)
      if (ret) return ret
    }
  }
}

export function getMeterEnergyIds1(_data) {
  map[1].meterId = []
  map[2].energyId = []
  if (!myCheck(_data)) {
    let fn = function (data) {
      for (const i in data) {
        if(data[i].type === 2){
          map[1].meterId.push(data[i].typeId)
          map[2].energyId.push(data[i].id)
        }else{
          fn(data[i].children)
        }
      }
    }
    fn(_data)
  }
  return map
}

export function getMeterEnergyIds(data) {
  if (!myCheck(data)) {
    map[1].meterId = []
    map[2].energyId = []
    for (const i in data) {
      map[1].meterId.push(data[i].typeId)
      map[2].energyId.push(data[i].id)
    }
  }
  return map
}

/**
 * 非空判断
 * @param values
 * @returns {boolean} true为空 false不为空
 */
function myCheck(...values) { /* true为空 */
  if (typeof values === undefined || values === null || values === '') return true
  let ret = true
  for (let i = 0; i < values.length; i++) {
    ret = typeof values[i] === undefined || values[i] === null || values[i] === ''
    if (ret === false) break
  }
  return ret
}

/**
 * 获取树形结构首个能耗单元用户
 * @param data
 * @returns {*}
 */
export function expandedCustomer(data) {
  if (data === null || data === undefined) return
  for (const i in data) {
    if (data[i].type + '' === '1') {
      return data[i].id
    }

    if (data[i].children !== undefined || data[i].children !== null) {
      const ret = expandedCustomer(data[i].children)
      if (ret) return ret
    } else {
      return null
    }
  }
}

/**
 * 获取树形结构首个能耗单元用户的父节点
 * @param data
 * @returns {*}
 */
export function expandedTenantPerentNode(data) {
  if (data === null || data === undefined) return
  for (const i in data) {
    if (data[i].type + '' === '1') {
      return data[i].father
    }

    if (data[i].children !== undefined || data[i].children !== null) {
      const ret = expandedTenantPerentNode(data[i].children)
      if (ret) return ret
    } else {
      return null
    }
  }
}

/* export function expandedCustomer(data,flag) {
  console.log(flag)
  if (data === null || data === undefined) return
  for (let i in data) {
    if (data[i].type + '' === '1' && (data[i].children !== undefined || flag)) {
      let user = data[i].id
      return {user,flag}
    }

    if (data[i].children !== undefined || data[i].children !== null) {
      let ret = expandedCustomer(data[i].children,flag)
      if (ret) return {ret,flag}
    }
    else {
      return {undefined,flag}
    }

  }
}*/

/* var expandedKeys = [];
export function  defaultExpandedKeys(data){
  expandedKeys=[];
  ExpandedKeys(data)
  return expandedKeys
}
function ExpandedKeys(data){
  if(data === null ||data === undefined) return
  if(data !== null) if(data[0] === null) return
  expandedKeys.push(data[0].id)
  if(data[0].children === null || data[0].children === undefined) return
  ExpandedKeys(data[0].children)
}*/
export function defaultExpandedKeys(data) { /* 树展开id 默认展开到树的第一个根节点*/
  const expandedKeys = []
  ExpandedKeys(data, expandedKeys)
  return expandedKeys
}

function ExpandedKeys(data, expandedKeys) {
  if (data === null || data === undefined) return
  if (data !== null) if (data[0] === null) return
  expandedKeys.push(data[0].id)
  if (data[0].children === null || data[0].children === undefined) return
  ExpandedKeys(data[0].children, expandedKeys)
}

export function filterNode(value,data){
  if (!value) return true

  let id,label

  if(data.type == 1 && data.code != null && data.label != null)
  {
    id = (data.code + '').indexOf(value)
    label = data.label.indexOf(value)
  }
  else if(data.type == 2 && data.father != null && data.father.code != null&& data.father.name != null)
  {
    id = (data.father.code + '').indexOf(value)
    label = data.father.name.indexOf(value)
  }
  else return false

  return (id !== -1 || label !== -1)
}

